import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
`;

export const ImageContainer = styled.div`
	position: relative;
	display: inline-block;
`;

export const Icon = styled.div`
	position: absolute;
	bottom: 0;
	right: -0.3rem;
	width: 1.2rem;
	height: 1.2rem;
	border-radius: 50%;
	opacity: 0.9;
`;

export const ImagePlaceholder = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	background-color: #ffeaa7;
	font-weight: 500;
`;
